export const LOCAL_STORAGE_APP_INSTANCE_ID_KEY = 'app_instance_id';

const generateAppInstanceId = () => Array.from({ length: 25 }, () => Math.random().toString(36)[2]).join('');

export const getAppInstanceIdItem = () => localStorage.getItem(LOCAL_STORAGE_APP_INSTANCE_ID_KEY) ?? '';
const setAppInstanceIdItem = () => localStorage.setItem(LOCAL_STORAGE_APP_INSTANCE_ID_KEY, generateAppInstanceId());

export const getAppInstanceId = () => {
  const appInstanceId = getAppInstanceIdItem();
  if (appInstanceId) return appInstanceId;

  const newAppInstanceId = generateAppInstanceId();
  localStorage.setItem(LOCAL_STORAGE_APP_INSTANCE_ID_KEY, newAppInstanceId);
  return newAppInstanceId;
};

export const getAppInstanceIdOrEmptyAndInitialize = () => {
  const appInstanceId = getAppInstanceIdItem();
  if (!appInstanceId) setAppInstanceIdItem();

  return appInstanceId;
};
